
const initialState = {
    person: null
};

function personReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        default:
            return state;
    }
}

export default personReducer;
